import { CloseCircleFilled, ExclamationCircleFilled, InfoCircleFilled } from '@ant-design/icons';
import styles from '../../treasury/elements/styles/pills.module.scss';
import { NOTIFICATION_SEVERITY } from '../../../constants/notifications.constants';

export const SEVERITY_LABELS = Object.freeze({
    [NOTIFICATION_SEVERITY.ERROR]: 'Error',
    [NOTIFICATION_SEVERITY.WARNING]: 'Warning',
    [NOTIFICATION_SEVERITY.INFO]: 'Info',
});

export const SEVERITY_ICONS = {
    [NOTIFICATION_SEVERITY.ERROR]: <CloseCircleFilled />,
    [NOTIFICATION_SEVERITY.WARNING]: <ExclamationCircleFilled />,
    [NOTIFICATION_SEVERITY.INFO]: <InfoCircleFilled />,
};

// Shared treasury tones — error → danger, warning → warning, info → neutral.
export const SEVERITY_TONES = {
    [NOTIFICATION_SEVERITY.ERROR]: styles.statusDanger,
    [NOTIFICATION_SEVERITY.WARNING]: styles.statusWarning,
    [NOTIFICATION_SEVERITY.INFO]: styles.statusNeutral,
};
